import { copyTextToClipboard } from '../helpers/copyToClipboard';

const AnchorLink = () => {
  const anchors = document.querySelectorAll('.js-anchor');
  let timeout = null;

  if (anchors.length !== 0) {
    anchors.forEach(anchor => {
      anchor.addEventListener('click', () => {
        const textToCopy = anchor.dataset.link;
        copyTextToClipboard(textToCopy);

        window.dataLayer.push({
          event: 'anchor link',
          eventType: 'anchor link copy click',
          anchorLink: textToCopy,
        });

        anchor.classList.add('is-link-copied');

        if (timeout !== null) {
          clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
          anchor.classList.remove('is-link-copied');
        }, 3000);
      });
    });
  }
};

export default AnchorLink;
